import PageHeader from '../../components/layout/PageHeader';
import ReviewQueue from '../../components/workflow/ReviewQueue';

/**
 * Manager's review queue — cases escalated to the manager for approval.
 *
 * Default scope is everything sitting in `pending_mgr`. Managers also have
 * read-only visibility into all other states via the same component, but
 * surfacing those by default would drown the actionable items.
 */
export default function ManagerReviewQueue(): JSX.Element {
  return (
    <>
      <PageHeader
        title="Manager review queue"
        subtitle="Cases escalated for your approval — contract reviews and KYC submissions."
      />
      <ReviewQueue
        defaultFilters={{
          // contract_review_v1 → pending_mgr (escalated by agent)
          // onboarding_retail  → pending_decision (agent finished review,
          //                      manager fires APPROVE/REJECT/RESTRICT —
          //                      replaced `under_review` 2026-05-25,
          //                      see memory kyc_review_actions_model),
          //                      pending_rejection (agent proposed rejection),
          //                      restricted (manager can clear back to review)
          state_slug: ['pending_mgr', 'pending_decision', 'pending_rejection', 'restricted'],
        }}
        detailPathPattern="/manager/cases/{caseId}"
        emptyHint="No cases awaiting your approval."
      />
    </>
  );
}
